/**
 * youtubeThumbnails — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {WIDE, tagline, chips, type ToilePack} from './data'

export const youtubeThumbnailsPack: ToilePack = {
    slug: 'youtube-thumbnails',
    category: 'thumbnail',
    name: 'Video thumbnails',
    tagline: tagline('thumbnails', 'topics', 'styles'),
    chips: chips('topics', 'styles'),
    ratio: WIDE,
    readings: [
        {key: 'tech', label: 'Tech review', subject: 'two hands holding a slim unbranded phone, a cable beside it'},
        {key: 'cooking', label: 'Cooking', subject: 'a skillet of golden crisp potatoes from above, a hand reaching in'},
        {key: 'travel', label: 'Travel vlog', subject: 'a backpacker from behind on a cliff path above a turquoise coast'},
    ],
    styles: [
        {key: 'pop', label: 'High-contrast pop', style: 'high-contrast pop, outlined subject', palette: 'saturated flat background, hard shadow', framing: '16:9, reads at small size'},
        {key: 'minimal', label: 'Clean minimal', style: 'clean minimal, restrained lettering', palette: 'soft neutral ground, one accent', framing: '16:9, reads at small size'},
        {key: 'cinematic', label: 'Cinematic', style: 'cinematic, shallow depth of field', palette: 'filmic grade, warm rim light', framing: '16:9, reads at small size'},
    ],
    directions: ['a fitness video instead', 'in yellow and black', 'with a face in frame'],
}
